import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-ald-mto-request-header',
  templateUrl: './ald-mto-request-header.component.html',
  styleUrls: ['./ald-mto-request-header.component.scss']
})
export class AldMtoRequestHeaderComponent implements OnInit {
  @Input() CompanyName: string;
  @Input() RequestFriendlyName: string;
  @Input() RequestSubmissionDate: Date;
  @Input() RequestStatus: string;
  @Input() comment: string;
  @Input() MTOCertificate: string
  constructor() { }

  ngOnInit() {
  }

}
